<template>
  <div class="field">
    <label
      class="label"
      :for="id"
    >
      Teléfono
    </label>
    <div
      class="control has-icons-left"
      :class="controlClass"
    >
      <input
        :id="id"
        ref="phoneNumber"
        :name="name"
        class="input"
        maxlength="16"
        :placeholder="placeholder"
        :pattern="phonePattern"
        :value="value"
        :disabled="disabled"
        :required="required"
        :readonly="readonly"
        @input="onInput"
        @change="onChange"
      >
      <b-icon
        class="is-small is-left is-unselectable"
        icon="phone"
      />
      <b-icon
        v-if="isValid && validIcon"
        class="is-small is-right is-unselectable has-text-success"
        icon="done"
      />
      <p class="help is-danger">
        El valor proporcionado no es un teléfono válido
      </p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'AppInputPhoneNumber',
  props: {
    id: {
      type: String,
      default: 'phoneNumber',
    },
    name: {
      type: String,
      default: 'phoneNumber',
    },
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '5512345678',
    },
    disabled: {
      type: Boolean,
    },
    isLoading: {
      type: Boolean,
    },
    readonly: {
      type: Boolean,
    },
    required: {
      type: Boolean,
      default: true,
    },
    validIcon: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      phonePattern: '^\\+?[0-9]?(\\(([0-9]{2,3})\\))?[0-9]{6,16}$',
      isValid: false,
    };
  },
  computed: {
    controlClass() {
      return {
        'has-icons-right': this.isValid && this.validIcon,
        'is-loading': this.isLoading,
      };
    },
  },
  watch: {
    value() { this.isValid = this.$refs.phoneNumber.checkValidity(); },
  },
  methods: {
    onInput(event) { this.$emit('input', event); },
    onChange(event) { this.$emit('change', event); },
  },
};
</script>

<style scoped>
.help.is-danger {
  position: absolute;
}
</style>
